import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';

@Injectable()
export class TessereService {
  private resourceUrl = environment.apiUrl + 'card';

  constructor(private http: HttpClient) {
  }

  getHeader(mock?: boolean): Observable<any> {
    if (mock) {
      return of(this.getHeaderMock());
    }
    return this.http.get<any>(this.resourceUrl + '/header');
  }

  getAllCardRequest(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getAllCardRequestMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/all/true');
  }

  getCardTypes(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getCardTypesMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/cost');
  }

  getGenerationData(mock?: boolean): Observable<any[]> {
    if (mock) {
      return of(this.getGenerationDataMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/generator/start');
  }

  getRequest(id: number, mock?: boolean): Observable<any> {
    if (mock) {
      return of(this.getRequestMock(id));
    }
    return this.http.get<any>(this.resourceUrl + '/detail/' + id);
  }

  requestCards(request: any, mock?: boolean): Observable<any> {
    if (mock) {
      return of(this.requestCardsMock());
    }
    return this.http.post<any>(this.resourceUrl + '/request', request);
  }

  requestReturnCard(request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/return', request);
  }

  sendCards(requestId: number, mock?: boolean): Observable<any> {
    if (mock) {
      return of(this.sendCardsMock(requestId));
    }
    return this.http.get<any>(this.resourceUrl + '/request_card/digital/' + requestId);
  }

  shipCards(request: any, requestId: number,  mock?: boolean): Observable<any> {
    if (mock) {
      return of(this.shipCardsMock(requestId));
    }
    return this.http.post<any>(this.resourceUrl + '/request/with_range/' + requestId, request);
  }

  returnCard(request: any, requestId: number): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/request/return/' + requestId, request);
  }

  deleteRequest(requestId: number,  mock?: boolean): Observable<any> {
    if (mock) {
      return of(this.deleteRequestMock(requestId));
    }
    return this.http.delete<any>(this.resourceUrl + '/request/' + requestId);
  }

  generateCard(request: any, mock?: boolean): Observable<any> {
    if (mock) {
      return of(this.requestCardsMock());
    }
    return this.http.post<any>(this.resourceUrl + '/generate_no_digital', request);
  }

  generateTecnicalCard(idSubscriber: number, request: any): Observable<Blob> {
    return this.http.post(this.resourceUrl + '/generate/' + idSubscriber, request, {responseType: 'blob'});
  }

  getCardTypesAndSeasons() {
    return this.http.get<any[]>(this.resourceUrl + '/types_and_seasons');
  }

  getRetractableCardTypes(mock?: boolean) {
    if (mock) {
      return of(this.getRetractableCardTypesMock());
    }
    return this.http.get<any[]>(this.resourceUrl + '/cost', {params: {retractable: 'true'}});
  }

  retractCards(idStructure: number, request: any) {
    return this.http.post<any>(this.resourceUrl + '/' + idStructure + '/return_cards', request);
  }

  removeCardFromSubscriber(idCard: number) {
    return this.http.delete<any>(this.resourceUrl + '/subscriber/' + idCard);
  }

  removeConiCardFromSubscriber(idCard: number, idSubscriber: number) {
    return this.http.delete<any>(this.resourceUrl + '/coni/' + idSubscriber + '/' + idCard);
  }
  assignPhysicalCards(idStructure: number, request: any) {
    return this.http.post<any>(this.resourceUrl + '/' + idStructure + '/assign_physical', request);
  }

  assignDigitalCards(idStructure: number, request: any) {
    return this.http.post<any>(this.resourceUrl + '/' + idStructure + '/assign_digital', request);
  }



private getRetractableCardTypesMock() {
    return [{
      id: 0,
      code: 'PHISICAL',
      description: 'Tessere cartacee',
      requestTypes: [
        {
          id: 0,
          code: 'COMPLETE',
          description: 'Completa',
          cost: 5
        },
        {
          id: 1,
          code: 'BASE',
          description: 'Base',
          cost: 2
        },
        {
          id: 2,
          code: 'ASSOCIATIVE',
          description: 'Associativa',
          cost: 10
        }
      ]
    }];
  }

  private getHeaderMock() {
    return {
      cardsLeft: [
        {
          type: {
            id: 0,
            code: 'BASE',
            description: 'Base'
          },
          leftCard: 100
        },
        {
          type: {
            id: 1,
            code: 'COMPLETE',
            description: 'Completa'
          },
          leftCard: 2000
        },
        {
          type: {
            id: 2,
            code: 'ASSOCIATIVE',
            description: 'Associativa'
          },
          leftCard: 7000
        }
      ],
      canRequest: true,
      canGenerate: true
    }
  }

  private getAllCardRequestMock() {
    return [
      {
        id: 1,
        type: {id: 2, code: 'C', description: 'C'},
        comitee: {id: 1, code: 'ASC', description: 'ASC'},
        date: '12/12/2012',
        detail: 'C50',
        cost: 0.0,
        state: 'REQ'
      },
      {
        id: 2,
        type: {id: 1, code: 'D', description: 'D'},
        comitee: {id: 1, code: 'ASC', description: 'ASC'},
        date: '12/12/2012',
        detail: 'C50',
        cost: 0.0,
        state: 'REQ'
      },
      {
        id: 3,
        type: {id: 2, code: 'C', description: 'C'},
        comitee: {id: 1, code: 'ASC', description: 'ASC'},
        date: '12/12/2012',
        detail: 'C50',
        cost: 0.0,
        state: 'SEN'
      }
    ]
  }

  private getCardTypesMock() {
    return [
      {
        id: 0,
        code: 'PHISICAL',
        description: 'Tessere cartacee',
        requestTypes: [
          {
            id: 0,
            code: 'COMPLETE',
            description: 'Completa',
            cost: 5
          },
          {
            id: 1,
            code: 'BASE',
            description: 'Base',
            cost: 2
          },
          {
            id: 2,
            code: 'ASSOCIATIVE',
            description: 'Associativa',
            cost: 10
          }
        ]
      },
      {
        id: 1,
        code: 'DIGITAL',
        description: 'Tessere digitali',
        requestTypes: [
          {
            id: 0,
            code: 'COMPLETE',
            description: 'Completa',
            cost: 2.5
          },
          {
            id: 1,
            code: 'BASE',
            description: 'Base',
            cost: 1
          },
          {
            id: 2,
            code: 'ASSOCIATIVE',
            description: 'Associativa',
            cost: 5
          }
        ]
      }
    ]
  }

  private getGenerationDataMock() {
    return [
      {
        id: 0,
        code: 'COMPLETE',
        description: 'Completa',
        start: 5
      },
      {
        id: 1,
        code: 'BASE',
        description: 'Base',
        start: 2
      },
      {
        id: 2,
        code: 'ASSOCIATIVE',
        description: 'Associativa',
        start: 10
      }
    ]
  }

  private getRequestMock(id: number) {
    return {
      id: 5,
      comitee: 'C.P. Trento',
      date: '12/12/2012',
      detail: '100C + 40A',
      type: {
        id: id,
        code: 'PHISICAL',
        description: 'Tessere cartacee'
      },
      requests: [
        {
          requestType: {
            id: 0,
            code: 'BASE',
            description: 'Base',
            cost: 2
          },
          amount: 100,
          cost: 200
        },
        {
          requestType: {
            id: 1,
            code: 'COMPLETE',
            description: 'Completa',
            cost: 5
          },
          amount: 100,
          cost: 500
        },
        {
          requestType: {
            id: 2,
            code: 'ASSOCIATIVE',
            description: 'Associativa',
            cost: 10
          },
          amount: 10,
          cost: 100
        },
      ],
      totalCost: 800,
      showCosts: true
    }
  }

  private requestCardsMock() {
    return {
      id: 4,
      type: {id: 2, code: 'C', description: 'C'},
      comitee: {id: 1, code: 'ASC', description: 'ASC'},
      date: '12/12/2012',
      detail: 'C50',
      cost: 0.0,
      state: 'REQ'
    }
  }

  private sendCardsMock(id: number) {
    return {
      id: id,
      type: {id: 2, code: 'C', description: 'C'},
      comitee: {id: 1, code: 'ASC', description: 'ASC'},
      date: '12/12/2012',
      detail: 'C50',
      cost: 0.0,
      state: 'SEN'
    }
  }

  private shipCardsMock(id: number) {
    return {
      id: id,
      type: {id: 2, code: 'C', description: 'C'},
      comitee: {id: 1, code: 'ASC', description: 'ASC'},
      date: '12/12/2012',
      detail: 'C50',
      cost: 0.0,
      state: 'SEN'
    }
  }

  private deleteRequestMock(id: number) {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/app/servizi/tessere/tessere.service.ts